import { gql, useMutation } from "@apollo/client";
import { parseError } from "apollo";
import { Alert } from "components/base/Toast";

const SEND_EMAIL = gql`
  mutation SEND_EMAIL($to: [String]!, $subject: String!, $message: String!) {
    sendEmail(to: $to, subject: $subject, message: $message) {
      success
    }
  }
`;

const useSendEmail = () =>
  useMutation(SEND_EMAIL, {
    onCompleted() {
      Alert("success", "Email sent successfully.");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
  });

export default useSendEmail;
